import cn from "classnames/bind";
import style from "./pageHeader.module.scss";

export const PageTitle = ({title, extra, small, middle, ...rest}) => {

    return (
        <>
            <div
                className={cn(style.wrapper, {
                    [style.middle]: middle,
                    [style.small]: small
                })}
                {...rest}
            >
                <div className={cn(style.head_wrapper)}>
                    <div className={cn(style.title)}>
                        {title}
                    </div>

                    <div className={cn(style.extra)}>
                        {extra}
                    </div>
                </div>
            </div>
        </>
    );
}